/**
 * Lightweight admin session persistence. Stores the HMAC session token
 * issued by /api/booths/{slug}/admin/verify in localStorage, keyed by
 * slug, with the server-issued expiry. Clears itself when expired.
 */
const KEY_PREFIX = 'booth-admin:';

interface StoredSession {
  token: string;
  expiresAtMs: number;
}

export function saveAdminSession(
  slug: string,
  token: string,
  expiresAtMs: number,
): void {
  try {
    localStorage.setItem(
      KEY_PREFIX + slug,
      JSON.stringify({ token, expiresAtMs }),
    );
  } catch {
    /* localStorage disabled */
  }
}

export function loadAdminSession(slug: string): StoredSession | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + slug);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredSession;
    if (!parsed.token || typeof parsed.expiresAtMs !== 'number') return null;
    if (parsed.expiresAtMs < Date.now()) {
      localStorage.removeItem(KEY_PREFIX + slug);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearAdminSession(slug: string): void {
  try {
    localStorage.removeItem(KEY_PREFIX + slug);
  } catch {
    /* localStorage disabled */
  }
}
